import { render } from "./RestoreRecordModal.vue?vue&type=template&id=a6826e20&ts=true"
import script from "./RestoreRecordModal.vue?vue&type=script&lang=ts"
export * from "./RestoreRecordModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__